import React, { useState, useEffect } from "react";
import { Box, Grid2, Stack, TextField, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { getUser } from "../../services/user.service";
import Autocomplete from "@mui/material/Autocomplete";
import { getAllProject, getReports } from "../../services/reports.service";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { Button, DatePicker } from "antd";
import { ToastError } from "../../utils/Toaster/Toaster";
const { RangePicker } = DatePicker;

const ProjectReport = () => {
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [data, setData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedEmployeeId, setselectedEmployeeId] = useState(null);
  const [projectDatas, setProjectDatas] = useState([]);
  const [totalHours, setTotalHours] = useState("");

  const columns = [
    { id: "date", label: "Date" },
    { id: "userName", label: "Name" },
    { id: "projectTitle", label: "Project Name" },
    { id: "totalActiveTime", label: "Total Active Time" },
  ];

  const tableConfig = {
    isAction: false,
    // isView: true,
    // isEdit: false,
    // isDelete: false,
    // isSearch: false,
    // isAddNew: false,
  };

  const handleUserChange = (event, value) => {
    if (value?.label === "All") {
      setSelectedEmployee("All");
      setselectedEmployeeId("All");
    } else {
      setSelectedEmployee(value?.name);
      setselectedEmployeeId(value?._id);
    }
  };

  const handleChange = (event, newValue) => {

    if (newValue === "All") {
      setSelectedProject("All");
      setSelectedProjectId("All");
    } else {
      const project = projectDatas.find((pro) => pro.title === newValue);
      setSelectedProject(project?.title);
      setSelectedProjectId(project?._id);
    }
  };

  const handleSearch = async () => {
    if (!selectedDateRange || !selectedEmployee || !selectedProject) {
      ToastError("Please select all the options");
      return;
    }
    try {
      const res = await getReports({
        date: selectedDateRange,
        userId: selectedEmployeeId,
        projectId: selectedProjectId,
      });
      if (res?.data) {
        const { totalHoursWorked, dailyReports } = res?.data;
        setData(dailyReports);
        setTotalHours(totalHoursWorked);
        // setTableTotalCount(dailyReports.length + 1);
      }
    } catch (error) {
      console.log("Error in fetching report", error);
    }
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const res = await getUser({ isEnabled: true });
        const configData = res.data.data.map((e) => ({
          ...e,
          label: e?.firstName + (e?.lastName ? " " + e.lastName : ""),
        }));
        setEmployeeData(configData);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployeeData();
  }, []);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await getAllProject();
        if (res?.data) {
          setProjectDatas(res?.data);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchProject();
  }, []);

  return (
    <div className="app-container">
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Box>{/* <h2>Reports</h2> */}</Box>
        <Stack direction={"row"} spacing={4} mb={1}>
          <Box>
            <Typography sx={{ fontSize: "18px" }}>
              Total Hours Worked
            </Typography>
          </Box>
          <Typography sx={{ fontSize: "18px" }}>{totalHours}</Typography>
        </Stack>
      </Stack>
      <Box>
        <Grid2 container spacing={4} mb={1} sx={{ width: "100%" }}>
          <Grid2 size={{ xs: 3 }}>
            <RangePicker
              value={selectedDateRange}
              onChange={(dates) => setSelectedDateRange(dates)}
              className="datePicker w-100"
              format={"DD-MM-YYYY"}
            />
          </Grid2>
          <Grid2 size={{ xs: 3 }}>
            <Autocomplete
              value={selectedEmployee || null}
              options={
                selectedProjectId === "All"
                  ? employeeData
                  : [{ label: "All", _id: null }, ...employeeData]
              }
              onChange={handleUserChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Employee"
                  className="AutoComplete_InputBox"
                />
              )}
              sx={{ width: 300 }}
            />
          </Grid2>
          <Grid2 size={{ xs: 3 }}>
            <Autocomplete
              value={selectedProject || null}
              onChange={handleChange}
              options={
                selectedEmployeeId === "All"
                  ? projectDatas.map((item) => item.title)
                  : ["All", ...projectDatas.map((item) => item.title)]
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Project"
                  className="AutoComplete_InputBox"
                />
              )}
              sx={{ width: 300 }}
            />
          </Grid2>
          <Grid2 size={{ xs: 3 }}>
            <Button
              startIcon={<SearchOutlinedIcon />}
              onClick={() => handleSearch()}
              className="Add-Button"
            >
              Search
            </Button>
          </Grid2>
        </Grid2>
        <MasterCommonTable
          tableConfig={tableConfig}
          data={data}
          columns={columns}
          tableTotalCount={data.length}
        />
      </Box>
    </div>
  );
};

export default ProjectReport;
